module.exports = __webpack_public_path__ + "static/media/QRcode.f1c8167c.svg";